/** All available debt collection task event statuses */
export enum DebtCollectionTaskEventStatusEnum {
  /** Event in progress */
  NEW = 'NEW',
  /** The event completed successfully */
  SUCCESS = 'SUCCESS',
  /** The event completed unsuccessfully */
  FAILED = 'FAILED',
}
